type Listener = () => void;

const listeners = new Set<Listener>();
let generation = 0;

/** Notifica a hooks de sesión empleado que deben re-leer el record. */
export function bumpEmployeePermissionsFreshness(): void {
  generation += 1;
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (e) {
      console.warn('[employeePermissionsFreshnessEvents]', e);
    }
  });
}

export function subscribeEmployeePermissionsFreshness(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getEmployeePermissionsFreshnessGeneration(): number {
  return generation;
}
